export enum MsgRevEventProps {
  log_in = "【creator】在电脑端登录或注册登录",
  search_gallery = "【creator】gallery调用接口搜索",
}
export interface MsgRevProps {
  eventParameters: {
    // 事件名
    event_name: MsgRevEventProps;
    // 事件ID
    event_id: keyof typeof MsgRevEventProps;
    // 事件类型
    event_type: "view" | "click" | "api";
    // 触发条件
    event_conditions?: string;
    // 额外参数
    property?: {
      search_text: string;
      source_action?: string; // 动作来源
    };
  };
  // 其他私有参数，如：模型ID、预览链接等等，可自行随意添加
  otherParameters?: any;
}
export function generateUUID() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
export const getDeviceId = () => {
  const deviceId = localStorage.getItem("deviceId");
  if (deviceId) {
    return deviceId;
  }
  const uuid = generateUUID();
  localStorage.setItem("deviceId", uuid);
  return uuid;
};
export const buriedPointGeneralParameters = {
  device_id: getDeviceId(),
  version: "1.0.0",
  os_version: navigator.platform,
  system_version: navigator.appVersion,
  screen_resolution: window.screen.width + "*" + window.screen.height,
  page_url: window.location.href,
  page_title: document.title,
  start_time: new Date().getTime(),
};
